if (PJQ.app.module === PJQ.constants.modules.PROJECTWALL) {
	PJQ.app.addOldRoutes([
		{
			route: '',
			name: 'default',
			callback: function () {
				PJQ.app.router.navigate('projects', {
					trigger: true,
					replace: true
				});
			}
		}
	]);
}

PJQ.modules.projectWall = {
	oldRoutes: [
		{
			route: "?projectid",
			callback: function (projectId) {
				PJQ.app.router.navigate('projects/' + projectId, {
					trigger: true,
					replace: true
				});
			}
		}
	],
	routes: [
		{
			route: 'projects/:projectId',
			name: 'projectRoot',
			callback: function (projectId) {
				let moduleName = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_DEFAULT_MODULE) ?
					PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_DEFAULT_MODULE) : 'dashboard';
				PJQ.app.router.navigate('projects/' + projectId.toString() + '/' + moduleName, {
					trigger: true,
					replace: true
				});
			}
		},
		{
			route: 'projects/:projectId/submitbid#tabPrivateMessage',
			name: 'projectSubmitBidLegacy',
			callback: function (projectId) {
				PJQ.app.session.set('submitBid', true);
				PJQ.app.router.navigate('projects/' + projectId, {
					trigger: true,
					replace: true
				});
			}
		},
		{
			route: 'projects/:projectId/SubmitBid#tabPrivateMessage',
			name: 'projectSubmitBidLegacy',
			callback: function (projectId) {
				PJQ.app.session.set('submitBid', true);
				PJQ.app.router.navigate('projects/' + projectId, {
					trigger: true,
					replace: true
				});
			}
		},
		{
			route: 'projects/:projectId/SubmitBid',
			name: 'projectSubmitBid',
			callback: function (projectId) {
				PJQ.app.session.set('submitBid', true);
				PJQ.app.router.navigate('projects/' + projectId, {
					trigger: true,
					replace: true
				});
			}
		},
		{
			route: 'projects/:projectId/submitbid',
			name: 'projectSubmitBid',
			callback: function (projectId) {
				PJQ.app.session.set('submitBid', true);
				PJQ.app.router.navigate('projects/' + projectId, {
					trigger: true,
					replace: true
				});
			}
		},
		{
			route: 'projects/:projectId/?response=:response',
			name: 'projectWithResponse',
			callback: function (projectId, response) {
				PJQ.app.session.set('bidStatus', response);
				PJQ.app.router.navigate('projects/' + projectId, {
					trigger: true,
					replace: true
				});
			}
		},
		{
			route: 'projects/:projectId/ACCEPT',
			name: 'projectWithAcceptResponse',
			callback: function (projectId) {
				PJQ.app.session.set('bidStatus', 'ACCEPT');
				PJQ.app.router.navigate('projects/' + projectId, {
					trigger: true,
					replace: true
				});
			}
		},
		{
			route: 'projects/:projectId/DECLINE',
			name: 'projectWithDeclineResponse',
			callback: function (projectId) {
				PJQ.app.session.set('bidStatus', 'DECLINE');
				PJQ.app.router.navigate('projects/' + projectId, {
					trigger: true,
					replace: true
				});
			}
		},
		{
			route: 'projects/:projectId/dashboard',
			name: 'projectDashboard',
			callback: function (projectId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "dashboard");
			}
		},
		{
			route: 'projects/:projectId/details',
			name: 'projectDetails',
			callback: function (projectId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "details", {
					detailedProject: true
				});
			}
		},
		{
			route: 'projects/:projectId/locations',
			name: 'projectDetails',
			callback: function (projectId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "locations");
			}
		},
		{
			route: 'projects/:projectId/mall',
			name: 'projectContainer',
			callback: function (projectId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "mall", {
					detailedProject: true
				});
			}
		},
		{
			route: 'projects/:projectId/messaging',
			name: 'projectMessaging',
			callback: function (projectId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "messaging");
			}
		},
		{
			route: 'projects/:projectId/messaging/:projectMessageId',
			name: 'projectMessagingView',
			callback: function (projectId, projectMessageId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "messaging", {
					viewProjectMessageId: projectMessageId
				});
			}
		},
		{
			route: 'projects/:projectId/messagingnew',
			name: 'projectMessaging',
			callback: function (projectId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "messagingnew");
			}
		},
		{
			route: 'projects/:projectId/messagingnew/:projectMessageId',
			name: 'projectMessagingViewNew',
			callback: function (projectId, projectMessageId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "messagingnew", {
					viewProjectMessageId: projectMessageId
				});
			}
		},
		{
			route: 'projects/:projectId/messaging/:projectMessageId/copy',
			name: 'projectMessagingCopy',
			callback: function (projectId, projectMessageId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "messaging", {
					copyProjectMessageId: projectMessageId
				});
			}
		},
		{
			route: 'projects/:projectId/messagingnew/:projectMessageId/copy',
			name: 'projectMessagingCopyNew',
			callback: function (projectId, projectMessageId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "messagingnew", {
					copyProjectMessageId: projectMessageId
				});
			}
		},
		{
			route: 'projects/:projectId/messaging/:projectMessageId/delete',
			name: 'projectMessagingDelete',
			callback: function (projectId, projectMessageId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "messaging", {
					deleteProjectMessageId: projectMessageId
				});
			}
		},
		{
			route: 'projects/:projectId/privatemessaging/view/:viewName',
			name: 'privateMessagingSent',
			callback: function (projectId, viewName) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "privatemessaging", {
					view: viewName,
					noRoute: true
				});
			}
		},
		{
			route: 'projects/:projectId/privatemessaging',
			name: 'privateMessaging',
			callback: function (projectId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "privatemessaging");
			}
		},
		{
			route: 'projects/:projectId/privatemessaging/:projectMessageId',
			name: 'privateMessagingMessage',
			callback: function (projectId, projectMessageId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "privatemessaging", {
					viewUserMessageId: projectMessageId
				});
			}
		},
		{
			route: 'projects/:projectId/documents',
			name: 'projectDocuments',
			callback: function (projectId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "projectdocuments");
			}
		},
		{
			route: 'projects/:projectId/attachments',
			name: 'projectAttachments',
			callback: function (projectId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "attachments");
			}
		},
		{
			route: 'projects/:projectId/submittalsold',
			name: 'submittalList',
			callback: function (projectId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "submittals_old");
			}
		},
		{
			route: 'projects/:projectId/submittals',
			name: 'submittalList',
			callback: function (projectId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "submittals");
			}
		},
		{
			route: 'projects/:projectId/submittals/:submittalId',
			name: 'submittal',
			callback: function (projectId, submittalId) {
				window.pjqSubmittalLoadId = submittalId;
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "submittals", {
					submittalId: submittalId
				});
			}
		},
		{
			route: 'projects/:projectId/reports',
			name: 'projectreports',
			callback: function (projectId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "projectreports");
			}
		},
		{
			route: 'projects/:projectId/reportsadhoc',
			name: 'projectreportsadhoc',
			callback: function (projectId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "projectreportsadhoc");
			}
		},
		{
			route: 'projects/:projectId/autoreport',
			name: 'autoReport',
			callback: function (projectId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "rsvpautoreport");
			}
		},
		{
			route: 'projects/:projectId/proposals',
			name: 'proposals',
			callback: function (projectId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "proposals");
			}
		},
		{
			route: 'projects/:projectId/messaging/context/:msgContext/:sessionId/new',
			name: 'projectMessagingContextOld',
			callback: function (projectId, msgContext, sessionId) {
				window.projectContactTemp = msgContext;
				window.pjqSessionId = sessionId;
				PJQ.app.session.set('sessionId', sessionId);
				window.isNewMsg = true;
				PJQ.app.router.navigate('projects/' + projectId + '/messaging', {
					trigger: true,
					replace: true
				});
			}
		},
		{
			route: 'projects/:projectId/messaging/context/:msgContext/:sessionId',
			name: 'projectMessagingContextOld',
			callback: function (projectId, msgContext, sessionId) {
				window.projectContactTemp = msgContext;
				window.pjqSessionId = sessionId;
				PJQ.app.session.set('sessionId', sessionId);
				window.isNewMsg = false;
				PJQ.app.router.navigate('projects/' + projectId + '/messaging', {
					trigger: true,
					replace: true
				});
			}
		},
	],
	initProjectNavigator(projectId, activeItem, viewOptions) {
		if (!PJQ.app.session.project || !PJQ.app.session.project.isFetched || PJQ.app.session.project.id !== projectId) {
			PJQ.app.session.project = new PJQ.models.projects.Project({
				projectId: projectId
			}, {isDetail: viewOptions != null && viewOptions.detailedProject === true});
			if (PJQ.app.session.project.id > 0) {
				PJQ.app.session.project.fetch({
					notify: false,
					success: function () {
						if (activeItem === 'dashboard' && PJQ.app.session.project.get('status') === 'ARCHIVE')
							activeItem = 'details';

						if (PJQ.app.session.project.get('masterUserId') !== PJQ.app.session.get('masterUserId')
							&& PJQ.app.session.project.nda != null) {
							new PJQ.views.projects.SignProjectNDAModal({
								model: PJQ.app.session.project,
								activeItem: activeItem,
								viewOptions: viewOptions
							});
							return;
						}

						let accessKey = PJQ.app.session.get('accessKey');
						if(!PJQ.app.session.project.get('isOnline') && (_.size(accessKey) > 0 || (PJQ.app.session.user && PJQ.app.session.user.id > 0 && PJQ.app.session.project.get('masterUserId') !== PJQ.app.session.get('masterUserId')))){
							new PJQ.views.BaseModal({
								header: "Project Access Error",
								body: "This project is currently marked Offline by an administrator.  Please try again at another time, or contact the Project's administrator.",
								onOk: function(){ window.location.href = window.location.origin}
							});
						}else {
						
							if (_.size(accessKey) > 0) {
								new PJQ.ajax.Request({
									endpoint: "/projects/" + PJQ.app.session.project.id + "/viewed?accessKey=" + accessKey
								}).post();
							}
							else if (PJQ.app.session.user && PJQ.app.session.user.id > 0 && PJQ.app.session.project.get('masterUserId') !== PJQ.app.session.get('masterUserId')) {
								new PJQ.ajax.Request({
									endpoint: "/projects/" + PJQ.app.session.project.id + "/viewed"
								}).post();
							}

							if (window.settings != null) {
								window.settings.SelectectContactGroupsTemp = [];
								window.settings.SelectectContactsTemp = [];
								window.settings.SharedFolderId = PJQ.app.session.project.get('sharedFolderId');
							}

							new PJQ.ajax.Request({
								endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
									{
										endpoint: 'session'
									},
									{
										endpoint: 'project',
										value: projectId
									}
								])
							}).get().done(_.bind(function () {
								let initNav = function () {
									PJQ.app.initNavigator({
										activeItem: activeItem,
										viewOptions: viewOptions
									});
								};
								if (PJQ.app.session.project.get('masterUserId') !== PJQ.app.session.get('masterUserId')) {
									PJQ.app.session.project.fetchUserMessageTypes(function () {
										let accessKey = PJQ.app.session.get('accessKey');
										if (_.size(accessKey) > 0) {
											PJQ.app.TokenManager.getTokensForAccessKey(accessKey, (success, error) => {
												initNav();
											});
											return;
										}

										initNav();
									});
								} else {
									initNav();
								}
							}, this))
						}
					},
					error: function (model, response) {
						if(response.status === 401 && _.size(PJQ.app.session.get('accessKey')) > 0){
							PJQ.notifications.notify.warningNotify({
								message: 'This access key has expired'
							});
						}
						else{
							new PJQ.ErrorHandler({}).handle(response, model.toJSON());
						}
						PJQ.app.router.navigate('/', {
							trigger: true,
							replace: true
						});
					}
				});
			}
			else {
				PJQ.notifications.notify.errorNotify({
					message: 'This project cannot be found currently'
				});
				PJQ.app.router.navigate('/', {
					trigger: true,
					replace: true
				});
			}
		}
		else {
			PJQ.app.initNavigator({
				activeItem: activeItem,
				viewOptions: viewOptions
			});
		}
	}
};

PJQ.app.addRoutes(PJQ.modules.projectWall.routes);
PJQ.app.addOldRoutes(PJQ.modules.projectWall.oldRoutes);
